import * as moment from 'moment';

export class ValidDominio {
	find: boolean;
	cantAsientos: number;
	habilitacion: boolean;
	inspeccionTecnica: boolean;
	poliza: boolean;
	vigenciaHastaHabilitacion: Date;
	vigenciaHastaInspeccionTecnica: Date;
	vigenciaHastaPoliza: Date;
	tacografoMarca: string;
	nroTacografo: string;
	interno: string;
	servicios: any[];
	tieneTasa: boolean;
	tieneMultas: boolean;
	prorroga: boolean;

	constructor(data = null) {
		if (data) {
			this.find = false;
			this.cantAsientos = data.cantAsientos;
			this.habilitacion = data.habilitacion;
			this.interno = data.interno;
			this.inspeccionTecnica = data.inspeccionTecnica;
			this.poliza = data.poliza;
			this.tacografoMarca = data.tacografoMarca;
			this.nroTacografo = data.nroTacografo;
			this.tieneTasa = data.tieneTasa;
			this.tieneMultas = data.tieneMultas;
			this.vigenciaHastaHabilitacion = data.vigenciaHastaHabilitacion
				? new Date(
						moment(data.vigenciaHastaHabilitacion)
							.utc(true)
							.format('YYYY-MM-DD[T]HH:mm:ss')
				  )
				: null;
			this.vigenciaHastaInspeccionTecnica = data.vigenciaHastaInspeccionTecnica
				? new Date(
						moment(data.vigenciaHastaInspeccionTecnica)
							.utc(true)
							.format('YYYY-MM-DD[T]HH:mm:ss')
				  )
				: null;
			if (this.vigenciaHastaInspeccionTecnica) {
				this.vigenciaHastaInspeccionTecnica = new Date(
					this.vigenciaHastaInspeccionTecnica.getFullYear(),
					this.vigenciaHastaInspeccionTecnica.getMonth(),
					this.vigenciaHastaInspeccionTecnica.getDate(),
					23,
					59,
					59
				);
			}

			this.vigenciaHastaPoliza = data.vigenciaHastaPoliza
				? new Date(
						moment(data.vigenciaHastaPoliza)
							.utc(true)
							.format('YYYY-MM-DD[T]HH:mm:ss')
				  )
				: null;
			this.servicios = data.servicios;
			this.prorroga = data.prorroga;
		}
	}
}
